const INDICATORS = [
  "Open Year-Round",
  "65 RV Sites",
  "Full Hookups",
  "30 & 50 Amp Service",
  "Near Falcon Lake",
];

/** Compact trust indicators used in the hero and reusable elsewhere. */
export function TrustStrip({ tone = "light" }: { tone?: "light" | "dark" }) {
  return (
    <ul
      className={
        tone === "light"
          ? "flex flex-wrap items-center gap-x-3 gap-y-2 text-cream/85"
          : "flex flex-wrap items-center gap-x-3 gap-y-2 text-forest-deep"
      }
    >
      {INDICATORS.map((item) => (
        <li
          key={item}
          className={
            tone === "light"
              ? "rounded-full border border-cream/25 bg-cream/8 px-3.5 py-1.5 text-xs font-semibold tracking-wide"
              : "rounded-full border border-forest/20 bg-secondary px-3.5 py-1.5 text-xs font-semibold tracking-wide"
          }
        >
          {item}
        </li>
      ))}
    </ul>
  );
}
